
import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
import Section from './Section';

interface CTASectionProps {
  fadeInUp: any;
  staggerContainer: any;
}

const CTASection: React.FC<CTASectionProps> = ({
  fadeInUp,
  staggerContainer
}) => {
  const navigate = useNavigate();

  return (
    <Section
      variants={staggerContainer}
      className="justify-center items-center overflow-hidden relative rolling-gradient-bg"
    >
      {/* Rolling gradient escuro animado */}
      <div className="absolute inset-0 rolling-gradient opacity-90"></div>
      
      {/* Overlay escuro adicional para garantir contraste */}
      <div className="absolute inset-0 bg-black/40"></div>

      {/* Main CTA Content */}
      <div className="relative flex-1 flex items-center justify-center z-10">
        <div className="max-w-5xl mx-auto text-center">
          <motion.div variants={fadeInUp}>
            <h2 className="text-4xl md:text-6xl font-bold text-white mb-8 leading-tight">
              Conexões que só acontecem entre quem já chegou lá e quem sabe onde quer chegar.
              <br />
              <span className="text-luxury-mediumPink/90">
                Na Interlaced, sucesso reconhece ambição.
              </span>
            </h2>
            <p className="text-2xl text-white/90 mb-8 font-medium">
              <span className="bg-gradient-to-r from-luxury-red via-luxury-mediumPink to-luxury-purple bg-clip-text text-transparent">
                Discreto. Exclusivo. Sofisticado.
              </span>
            </p>
            <p className="text-xl text-white/70 mb-12 max-w-4xl mx-auto leading-relaxed">
              Um espaço reservado para quem busca mais do que encontros: busca poder compartilhado, sem ruídos e com classe.
            </p>
            
            <Button 
              size="lg" 
              className="bg-gradient-to-r from-luxury-red via-luxury-mediumPink to-luxury-purple hover:from-luxury-red/90 hover:via-luxury-mediumPink/90 hover:to-luxury-purple/90 text-white px-12 py-6 text-xl rounded-full transition-all duration-300 transform hover:scale-105 shadow-2xl shadow-luxury-red/30" 
              onClick={() => navigate('/auth')}
            >
              Começar agora
              <ArrowRight className="ml-3 w-6 h-6" />
            </Button>
          </motion.div>
        </div>
      </div>
    </Section>
  );
};

export default CTASection;
